exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form__request[data-v-79e68eca]{border:1px solid #ced4da;border-radius:5px}.form__request[data-v-79e68eca]:not(:last-child){margin-bottom:20px}.request__header[data-v-79e68eca]{position:relative;font-size:17px;padding:.75rem}.request__body[data-v-79e68eca]{padding:.75rem;border-top:1px solid #ced4da}.arr-down[data-v-79e68eca]{right:.75rem;top:50%;width:15px;height:15px}.arr-down[data-v-79e68eca],.arr-down svg[data-v-79e68eca]{-webkit-transition:.3s;transition:.3s}.arr-down.closed svg[data-v-79e68eca]{-webkit-transform:rotate(180deg);transform:rotate(180deg)}", ""]);

// exports
